import { render, staticRenderFns } from "./VekaletUcretiHesaplayiciView.vue?vue&type=template&id=0996e298"
import script from "./VekaletUcretiHesaplayiciView.vue?vue&type=script&lang=ts"
export * from "./VekaletUcretiHesaplayiciView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports